import React, { SVGProps, useMemo } from 'react';

export const AIStarIcon = (props: SVGProps<SVGSVGElement>) => {
  const gradientId = useMemo(
    () => `ai-star-gradient-${Math.random().toString(36).slice(2, 9)}`,
    [],
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill={`url(#${gradientId})`}
        d="M19.8 1.541c.55 1.663 1 2.115 2.66 2.666a.777.777 0 0 1 0 1.48c-1.66.55-2.11 1.002-2.66 2.665a.774.774 0 0 1-1.476 0c-.549-1.663-1-2.116-2.66-2.666a.75.75 0 0 1-.536-.734c0-.317.183-.623.537-.745 1.659-.55 2.11-1.003 2.66-2.666a.774.774 0 0 1 1.476 0Zm-2.879 9.39 2.453.71v-.012a1.69 1.69 0 0 1 1.207 1.614c0 .745-.5 1.406-1.22 1.614l-2.452.697a5.517 5.517 0 0 0-3.806 3.815l-.708 2.457c-.207.697-.842 1.174-1.61 1.174-.769 0-1.403-.465-1.61-1.174l-.708-2.457c-.537-1.86-1.953-3.29-3.807-3.815l-2.452-.71A1.69 1.69 0 0 1 1 13.23c0-.745.5-1.406 1.22-1.614l2.452-.697A5.517 5.517 0 0 0 8.48 7.104l.707-2.457c.208-.71.867-1.21 1.61-1.21.745 0 1.404.5 1.611 1.21l.708 2.47c.537 1.858 1.952 3.289 3.806 3.815Z"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="1"
          x2="23"
          y1="1"
          y2="23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E54800" />
          <stop offset=".5" stopColor="#FE8624" />
          <stop offset="1" stopColor="#FFAB64" />
        </linearGradient>
      </defs>
    </svg>
  );
};
